module.exports = "/wp-content/themes/conversion/public/dist//svgs/icon-chevrron-plus.svg";